import PAImage from "component/design-system/images/PAImage";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { RootState } from "interfaces/generics.type";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import { useSelector } from "react-redux";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import styles from "./account-overview.module.scss";

function AccountOverview() {
  const { firstName } = useSelector((state: RootState) => state.authenticationState);
  const { t } = useTranslation("home");

  return (
    <div style={{ backgroundColor: "white", height: "max-content", padding: "0.3rem 1rem" }} className="d-flex justify-content-between">
      <div className={styles.grid_item}>
        <div className={styles.info_box}>
          <PAImage
            src={getRelativeImagePath("/cms/pubicImages/images/account-user.png")}
            width={55}
            height={55}
            className="p-l-10 p-r-10"
            alt="pa-avatar"
          />
          <PAText fontSize={FONT_SIZE[2]} bold className="m-t-10 m-b-10" color="black">
            {`Hi, ${firstName}!`}
          </PAText>
        </div>
      </div>

      <div className={styles.grid_item}>
        <Link
          href="/account/orders"
          className={`${styles.icon_inner_container} ${styles.info_box}`}
        >

          <PAText fontSize={FONT_SIZE[0]} className="m-t-10 m-b-10" color="success-secondary">
            {t("Track orders")}
          </PAText>

        </Link>
      </div>
    </div>
  );
}

export default AccountOverview;
